import { useQuery } from '@tanstack/vue-query';
import { getCoreAxiosInstance } from '@utils/axios';
import store from '@state/store';
import { localPersister, queryClient as appClient } from './client';

const api = getCoreAxiosInstance();

// The top bar mounts on the login page too, where a 401 would run logOut.
const loggedIn = () => store.getters['auth/loggedIn'];

export const notificationKeys = {
  all: () => ['notifications'],
  latest: () => ['notifications', 'latest'],
  count: () => ['notifications', 'count'],
};

// Stored between visits, so a reload within 30 minutes shows them without asking again.
const persisted = {
  staleTime: 30 * 60 * 1000,
  persister: localPersister.persisterFn,
  // a load or mark-all-read refreshes them, not coming back to the tab
  refetchOnWindowFocus: false,
};

// The top bar's newest three
export const latestNotificationsQuery = () => ({
  queryKey: notificationKeys.latest(),
  queryFn: () => api.get('/notifications/', { params: { limit: 3, offset: 0 } }).then((res) => res.data.rows),
  ...persisted,
});

export const notificationCountQuery = () => ({
  queryKey: notificationKeys.count(),
  queryFn: () => api.get('/notifications/count').then((res) => res.data),
  ...persisted,
});

export const useNotifications = () => {
  const { data: notifications } = useQuery({ ...latestNotificationsQuery(), enabled: loggedIn });
  const { data: notificationCount } = useQuery({ ...notificationCountQuery(), enabled: loggedIn });
  return { notifications, notificationCount };
};

export const refreshNotifications = (client = appClient) =>
  client.invalidateQueries({ queryKey: notificationKeys.all() });
